/* Social-Proof-Landingpage: Rotation, Slider, Videos und Kaufbox.
   Jede Section initialisiert sich über data-wb-sp-* selbst, auch nach
   einem Reload im Theme-Editor. */
(function () {
  if (window.WbSp) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rotate(root, itemSel, dotSel, interval) {
    var items = root.querySelectorAll(itemSel);
    var dots = dotSel ? root.querySelectorAll(dotSel) : [];
    if (items.length < 2) return null;
    var index = 0;
    var timer = null;
    function show(i) {
      index = (i + items.length) % items.length;
      items.forEach(function (el, n) { el.classList.toggle('is-active', n === index); el.setAttribute('aria-hidden', n === index ? 'false' : 'true'); });
      dots.forEach(function (el, n) { el.classList.toggle('is-active', n === index); });
    }
    function start() {
      stop();
      if (!reduceMotion) timer = setInterval(function () { show(index + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    show(0);
    start();
    return { show: show, next: function () { show(index + 1); start(); }, prev: function () { show(index - 1); start(); } };
  }

  function initBar(root) {
    rotate(root, '.wb-sp-bar__msg', null, 5000);
  }

  function initBadges(root) {
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    rotate(root, '.wb-sp-badges__item', '.wb-sp-badges__dot', interval);
  }

  function initSlider(root) {
    var track = root.querySelector('.wb-sp-slider__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dotsWrap = root.querySelector('.wb-sp-slider__dots');
    var prev = root.querySelector('[data-wb-sp-prev]');
    var next = root.querySelector('[data-wb-sp-next]');
    var counter = root.querySelector('[data-wb-sp-counter]');

    function perView() {
      if (!slides.length) return 1;
      var w = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return Math.max(1, Math.round((track.clientWidth - parseFloat(getComputedStyle(track).paddingLeft) * 2 + gap) / (w + gap)));
    }
    function pages() { return Math.max(1, Math.ceil(slides.length / perView())); }
    function current() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return 0;
      return Math.round((track.scrollLeft / max) * (pages() - 1));
    }
    function go(page) {
      var n = pages();
      /* Am Ende wieder von vorn, am Anfang nach hinten. */
      var p = ((page % n) + n) % n;
      var target = slides[Math.min(slides.length - 1, p * perView())];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function renderDots() {
      if (!dotsWrap) return;
      var n = pages();
      dotsWrap.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wb-sp-slider__dot';
        b.setAttribute('aria-label', 'Seite ' + (i + 1));
        b.addEventListener('click', go.bind(null, i));
        dotsWrap.appendChild(b);
      }
      dotsWrap.hidden = n < 2;
    }
    function update() {
      var c = current();
      var n = pages();
      if (dotsWrap) dotsWrap.querySelectorAll('.wb-sp-slider__dot').forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
      if (counter) counter.textContent = (c + 1) + '/' + n;
      var nav = root.querySelector('.wb-sp-slider__nav');
      if (nav) nav.hidden = n < 2;
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { renderDots(); update(); });
    renderDots();
    update();
  }

  function initVideos(root) {
    root.querySelectorAll('.wb-sp-video').forEach(function (card) {
      var video = card.querySelector('video');
      var btn = card.querySelector('.wb-sp-video__play');
      if (!video || !btn) return;
      video.removeAttribute('controls');
      btn.addEventListener('click', function () {
        root.querySelectorAll('.wb-sp-video.is-playing video').forEach(function (other) {
          if (other !== video) { other.pause(); }
        });
        video.controls = true;
        video.play();
        card.classList.add('is-playing');
      });
      video.addEventListener('pause', function () { if (video.ended) card.classList.remove('is-playing'); });
      video.addEventListener('play', function () {
        root.querySelectorAll('video').forEach(function (other) { if (other !== video && !other.paused) other.pause(); });
      });
    });
  }

  /* Der Slidecart ist das Objekt `const CartDrawer` aus
     sections/cart-drawer-new-with-more-products.liquid. Als const hängt es
     nicht an window, deshalb über den nackten Namen ansprechen, wie in
     snippets/tw-joints-upsell.liquid. */
  function themeDrawer() {
    try {
      /* global CartDrawer */
      if (typeof CartDrawer !== 'undefined' && CartDrawer && typeof CartDrawer.refreshCart === 'function') return CartDrawer;
    } catch (e) {}
    return null;
  }

  function openCart() {
    var drawer = themeDrawer();
    if (drawer) {
      drawer.openCart();
      return drawer.refreshCart();
    }
    var drawerEl = document.querySelector('.cart-drawer');
    var bgEl = document.querySelector('.cart-drawer-bg');
    if (drawerEl && bgEl) {
      document.body.classList.add('cart-drawer-open');
      drawerEl.classList.add('is-active');
      bgEl.classList.add('is-active');
      return;
    }
    window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
  }

  function initOffer(root) {
    var packs = root.querySelectorAll('.wb-sp-pack');
    var images = root.querySelectorAll('.wb-sp-offer__img');
    var button = root.querySelector('[data-wb-sp-buy]');
    var error = root.querySelector('.wb-sp-offer__error');
    var selected = null;

    function select(pack) {
      selected = pack;
      packs.forEach(function (p) { p.classList.toggle('is-selected', p === pack); });
      var key = pack.getAttribute('data-image-key');
      var matched = false;
      images.forEach(function (img) {
        var hit = img.getAttribute('data-image-key') === key;
        if (hit) matched = true;
        img.classList.toggle('is-active', hit);
      });
      if (!matched && images.length) images[0].classList.add('is-active');
      if (error) error.classList.remove('is-visible');
    }

    packs.forEach(function (pack) {
      var input = pack.querySelector('input');
      if (input) input.addEventListener('change', function () { select(pack); });
      if (input && input.checked) select(pack);
    });
    if (!selected && packs.length) {
      select(packs[0]);
      var first = packs[0].querySelector('input');
      if (first) first.checked = true;
    }

    if (!button) return;
    button.addEventListener('click', function () {
      if (!selected) return;
      var variantId = parseInt(selected.getAttribute('data-variant-id'), 10);
      var quantity = parseInt(selected.getAttribute('data-quantity'), 10) || 1;
      var discount = selected.getAttribute('data-discount') || '';
      if (!variantId) {
        if (error) error.classList.add('is-visible');
        return;
      }
      var base = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      button.disabled = true;
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add');
          if (!discount) return null;
          return fetch(base + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: discount })
          });
        })
        .then(openCart)
        .catch(function () { if (error) error.classList.add('is-visible'); })
        .finally(function () { button.disabled = false; });
    });
  }

  /* Akkordeons: weich auf- und zuklappen, immer nur ein Eintrag je Liste
     offen. Die Höhe des Inhalts wird per Web Animations animiert, weil
     <details> selbst nicht animierbar ist. */
  var ACC_MS = 360;
  var ACC_EASE = 'cubic-bezier(0.33, 1, 0.68, 1)';

  function accBody(item) { return item.querySelector(':scope > .wb-sp-acc__body'); }

  function accStop(item) {
    if (item.__wbAnim) { item.__wbAnim.cancel(); item.__wbAnim = null; }
    var body = accBody(item);
    if (body) { body.style.overflow = ''; }
    item.classList.remove('is-closing');
  }

  function accFrames(body) {
    var cs = getComputedStyle(body);
    return {
      from: { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 },
      to: { height: body.scrollHeight + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, opacity: 1 }
    };
  }

  function accOpen(item) {
    accStop(item);
    item.open = true;
    var body = accBody(item);
    if (!body || reduceMotion || !body.animate) return;
    var f = accFrames(body);
    body.style.overflow = 'hidden';
    var anim = body.animate([f.from, f.to], { duration: ACC_MS, easing: ACC_EASE });
    item.__wbAnim = anim;
    anim.onfinish = function () { item.__wbAnim = null; body.style.overflow = ''; };
  }

  function accClose(item) {
    accStop(item);
    var body = accBody(item);
    if (!body || reduceMotion || !body.animate) { item.open = false; return; }
    var f = accFrames(body);
    body.style.overflow = 'hidden';
    item.classList.add('is-closing');
    var anim = body.animate([f.to, f.from], { duration: ACC_MS * 0.85, easing: ACC_EASE });
    item.__wbAnim = anim;
    anim.onfinish = function () {
      item.__wbAnim = null;
      item.open = false;
      body.style.overflow = '';
      item.classList.remove('is-closing');
    };
  }

  document.addEventListener('click', function (e) {
    var head = e.target.closest && e.target.closest('.wb-sp-acc__item > .wb-sp-acc__head');
    if (!head || head.tagName !== 'SUMMARY') return;
    var item = head.parentElement;
    e.preventDefault();
    if (item.open && !item.classList.contains('is-closing')) {
      accClose(item);
      return;
    }
    var list = item.closest('.wb-sp-acc');
    if (list) {
      list.querySelectorAll('details.wb-sp-acc__item[open]').forEach(function (other) {
        if (other !== item && !other.classList.contains('is-closing')) accClose(other);
      });
    }
    accOpen(item);
  });

  /* Sprungmarken auf der Seite (Siegel zu den Bewertungen, Buttons zum
     Angebot) weich anscrollen. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.wb-sp a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  var inits = { bar: initBar, badges: initBadges, slider: initSlider, videos: initVideos, offer: initOffer };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wb-sp]').forEach(function (el) {
      if (el.__wbSp) return;
      el.__wbSp = true;
      el.getAttribute('data-wb-sp').split(' ').forEach(function (name) {
        if (inits[name]) inits[name](el);
      });
    });
  }

  window.WbSp = { init: initAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
